$(function() {
    var className = 'tab-content';
    var scrollTop;
    var scrollDuration = 300;

    $('.js-' + className).each(function() {
        var el = $(this);
        var tab = el.find('.' + className + '__tab');
        var content = el.find('.' + className + '__content');

        tab.eq(0).addClass(className + '__tab--active');
        content.eq(0).addClass(className + '__content--active');

        tab.on('click', function() {
            var i = $(this).index();
            var acordion = el.find('.' + className + '__content--active').find('.accordion');
            scrollTop = $(window).scrollTop();

            if (acordion.length > 0) {
                el.find('.' + className + '__content--active').find('.accordion').data().fn.closeTab();
            }

            el.find('.' + className + '__tab--active').removeClass(className + '__tab--active');
            el.find('.' + className + '__content--active').removeClass(className + '__content--active');
            el.find('.' + className + '__tab').eq(i).addClass(className + '__tab--active');
            el.find('.' + className + '__content').eq(i).addClass(className + '__content--active');

            if (acordion.length > 0) {
                el.find('.' + className + '__content--active').find('.accordion').data().fn.open();
            }

            if (scrollTop != $(window).scrollTop()) {
                $(window).scrollTop(scrollTop);
            }

            scroll($(this));

            window.initMap();

            var equalise = new EqualiseHeight($('.js-equalise-height'));

            equalise.init();
            equalise.update();
        });
    });

    function scroll(el) {
        var items = [
            $('.navigation__header'),
            $('.cta-bar'),
            $('#debug-bar'),
            $('#admin-bar')
        ];
        scrollTop = el.offset().top - 20;

        for (var i = 0; i < items.length; i++) {
            if (items[i].length > 0) {
                scrollTop -= items[i].height();
            }
        }

        $('html, body').animate({
            scrollTop: scrollTop
        }, {
            duration: scrollDuration
        });
    }
});
